import { Layout, News as NewsComponent } from "components"
export const News = () => {
 return (
  <Layout>
   <NewsComponent />
  </Layout>
 )
}
